export {
  default as paddles,
  ReactComponent as Paddles,
} from '@assets/icons/features-and-amenities/paddles.svg'    
